const API = 'https://admin.ethicssocioeconomics.com/api/1.0';

export default {
  API,
};
